export default {
  links: [
    {
      title: 'Card machines',
      url: '/za/credit-card-readers/',
      isDisabled: false,
    },
    {
      title: 'Online Payments',
      isDisabled: false,
      links: [
        {
          title: 'Overview',
          url: '/za/product-overview/',
          isDisabled: false,
        },
        {
          title: 'Payment Request',
          url: '/za/payment-request/',
          isDisabled: false,
        },
        {
          title: 'Gift Vouchers',
          url: '/za/gift-vouchers/',
          isDisabled: false,
        },
        {
          title: 'Payment Page',
          url: '/za/payment-page/',
          isDisabled: false,
        },
        {
          title: 'Payment Gateway',
          url: '/za/payment-gateway/',
          isDisabled: false,
        },
      ],
    },
    {
      title: 'Fees',
      url: '/za/transaction-fees',
      isDisabled: false,
    },
    {
      title: 'Business tools',
      isDisabled: false,
      links: [
        {
          title: 'Point of Sale',
          url: '/za/point-of-sale-app/',
          isDisabled: false,
        },
        {
          title: 'Business Portal',
          url: '/za/portal/',
          isDisabled: false,
        },
        {
          title: 'Capital',
          url: '/za/capital/',
          isDisabled: false,
        },
        {
          title: 'Integrations',
          url: '/za/integrations/',
          isDisabled: false,
        },
      ],
    },
    {
      title: 'Resources',
      isDisabled: false,
      links: [
        {
          title: 'COVID-19 Guide',
          url: 'https://www.yoco.co.za/blog/covid-19-small-business-guide/',
          isDisabled: false,
          target: '_blank',
        },
        {
          title: 'Small Business Recovery Monitor',
          url: 'https://www.yoco.co.za/blog/covid-19-recovery-monitor/',
          isDisabled: false,
          target: '_blank',
        },
        {
          title: 'Help Center',
          url: 'https://get.yoco.help/hc/en-za',
          isDisabled: false,
          target: '_blank',
        },
        {
          title: 'Blog',
          url: 'https://www.yoco.co.za/blog',
          isDisabled: false,
          target: '_blank',
        },
        {
          title: 'Small Business Directory',
          url: 'https://yoco.supportsmall.co.za/',
          isDisabled: false,
          target: '_blank',
        },
        {
          title: 'Shop',
          url: 'https://yoco.store/',
          isDisabled: false,
          target: '_blank',
        },
      ],
    },
    {
      title: 'Contact',
      url: '/za/contact',
      isDisabled: false,
    },
  ],
}



// WEBPACK FOOTER //
// ./includes/yoco-website-cms-gatsby/src/utils/mocks/mockNavigation.js